<template>

    <div>

        <b-row>

            <b-col lg="12">

                <b-card>

                    <b-row>

                        <b-col>

                            <b-alert variant="info" show>It is not necessary to run "Generate Report" before "Export to Excel". Exporting may take a few minutes, and will run in a separate tab. Please wait for each export to finish before starting another, do not run multiple exports at the same time.</b-alert>
                        </b-col>
                    </b-row>

                    <b-row>

                        <b-col sm="6" md="4" class="d-flex align-items-center justify-content-between my-1">

                            <date-picker
                                v-model="start_date"
                                placeholder="Start Date"
                                class="f-1">
                            </date-picker> &nbsp;to&nbsp;
                            <date-picker
                                v-model="end_date"
                                placeholder="End Date"
                                class="f-1">
                            </date-picker>
                        </b-col>
                        <b-col sm="6" md="4" class="my-1" v-if=" caregiver == null ">

                            <user-role-search-dropdown type="provider" v-model=" caregiver_id " :client=" client "></user-role-search-dropdown>
                        </b-col>
                        <b-col sm="6" md="4" class="my-1" v-if=" client == null ">

                            <user-role-search-dropdown type="claimant" v-model=" client_id " :caregiver=" caregiver "></user-role-search-dropdown>
                        </b-col>
                        <b-col sm="6" md="4" class="my-1">

                            <b-form-select v-model=" flag_filter ">

                                <option value="">-- Filter by Flags --</option>
                                <option value="any">Has Any Flag</option>
                                <option value="none">Has No Flags</option>
                                <option value="disputed">Disputed</option>
                                <option value="time_excessive">Excessively Long</option>
                                <option value="added">Manually Added</option>
                                <option value="modified">Modified</option>
                                <option value="time_expire">Time Expired</option>
                                <option value="hospital_stay">Hospital Stay</option>
                            </b-form-select>
                        </b-col>
                        <b-col sm="6" md="4" class="my-1">

                            <b-form-select v-model=" verified_filter ">

                                <option value="">-- Filter Verified --</option>
                                <option value="1">Verified Shifts</option>
                                <option value="0">Unverified Shifts</option>
                            </b-form-select>
                        </b-col>
                        <b-col sm="6" md="4" class="my-1" v-if=" !isCarrierManager ">

                            <carrier-parents-dropdown v-model=" parent_carrier " :role=" role "></carrier-parents-dropdown>
                        </b-col>
                        <b-col sm="6" md="4" class="my-1">

                            <carrier-dropdown v-model=" carrier " :role=" role "></carrier-dropdown>
                        </b-col>
                    </b-row>

                    <b-row class="my-2">

                        <b-col sm="6">
                            <b-btn :href=" `/business/shifts/create?scopedUser=${scopeduser}` " target="_blank" variant="info" class="mr-1" v-if=" !isCarrierManager && manual ">Add a Manual Visit</b-btn>
                            <b-btn @click="columnsModal = true" variant="primary" class="my-1">Show or Hide Columns</b-btn>
                        </b-col>
                        <b-col sm="6" class="text-right">

                            <b-button @click=" loadTable() " variant="info" class="my-1 mr-1" :disabled=" loading ">Generate Report</b-button>
                            <b-btn @click=" exportXls() " variant="success" class="my-1 mr-1" :disabled=" loading "><i class="fa fa-file-excel-o"></i> Export to Excel</b-btn>
                            <b-btn @click=" printTable() " variant="primary" class="my-1 mr-1"><i class="fa fa-print"></i> Print</b-btn>
                        </b-col>
                    </b-row>

                    <div class="table-responsive">

                        <b-row class="my-4">

                            <b-col lg="3">

                                <b>Total Shifts:</b> {{ totalRows }}
                            </b-col>
                            <b-col lg="3">

                                <b>Total Hours:</b> {{ totalHours }}
                            </b-col>
                            <b-col lg="3">

                                <b>Total Hourly:</b> {{ totalCost }}
                            </b-col>
                            <!-- <b-col lg="3">

                                <b>Total Flags:</b> {{ totalFlags }}
                            </b-col> -->
                        </b-row>

                      <div id="loader" v-show="loading">
                        <b-spinner label="Spinning"></b-spinner>
                      </div>

                        <!-- <h3>Total Count: {{ total_count }}</h3> -->
                        <b-table bordered striped hover show-empty
                            :fields="fields"
                            :items="shiftHistoryItems"
                            :sort-by.sync=" sortBy "
                            :sort-desc.sync=" sortDesc "
                            class="shift-table"
                            :busy=" loading "
                            v-show="!loading"
                        >
                            <template v-slot:cell(Day)="row">
                              <div v-if="row.item.checked_in_time !== 'Total'">
                                <utc-time :role="role" :time="row.item.checked_in_time"  :timezone="row.item.shift_timezone" format="ddd MMM DD" />
                              </div>
                              <div v-else>
                                <span>Total</span>
                              </div>
                            </template>
                            <template v-slot:cell(Claimant)="row">
                                <a :href=" `${claimantUrlPrefix}/${row.item.client_id}` " target="_blank">{{ row.item['Claimant'] }}</a>
                            </template>
                            <template v-slot:cell(Provider)="row">
                                <a :href=" `${providerUrlPrefix}/${row.item.caregiver_id}` " target="_blank">{{ row.item.Provider }}</a>
                            </template>

                            <template v-slot:cell(EVV)="data">
                                <span v-if="data.value" style="color: green">
                                    <i class="fa fa-check-square-o"></i>
                                </span>
                                    <span v-else-if="data.value === undefined"></span>
                                    <span v-else style="color: darkred">
                                    <i class="fa fa-times-rectangle-o"></i>
                                </span>
                            </template>
                            <template v-slot:cell(Time)="data">
                                <span v-text="data.value" />
                            </template>
                            <template v-slot:cell(Confirmed)="data">
                                {{ (data.value) ? 'Yes' : (data.value === undefined) ? '' : 'No' }}
                            </template>
                            <template v-slot:cell(flags)="row">
                                <span v-if="row.item.id">
                                    <shift-flag-icons :flags="row.item.flags" />
                                </span>
                                <span v-else>
                                    {{ row.item.flags }}
                                </span>
                            </template>
                            <template v-slot:cell(actions)="row">
                                <span v-if="row.item.id">
                                    <b-btn size="sm" target="_blank" :href=" `/${controller}/shifts/${row.item.id}` " variant="info" v-b-tooltip.hover title="Edit" v-if=" !isCarrierManager "><i class="fa fa-edit"></i></b-btn>
                                    <b-btn size="sm" @click.stop="details(row.item)" v-b-tooltip.hover title="View"><i class="fa fa-eye"></i></b-btn>
                                    <b-btn size="sm" @click.stop="deleteShift(row.item)" variant="danger" v-b-tooltip.hover title="Delete" v-if=" !isCarrierManager "><i class="fa fa-times"></i></b-btn>
                                </span>
                                <span v-else>
                                    {{ items.shifts.length }} Shifts
                                </span>
                            </template>
                        </b-table>
                    </div>

                    <b-row>

                        <b-col lg="6">

                            <b-pagination :total-rows=" totalRows " :per-page=" perPage " v-model=" currentPage " />
                        </b-col>
                        <b-col lg="6" class="text-right">

                            {{ paginationText }}
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <!-- Filter columns modal -->
        <b-modal id="filterColumnsModal" title="Show or Hide Columns" v-model=" columnsModal ">

            <b-container fluid>

                <b-row>

                    <div class="form-check row">

                        <div class="col-sm-auto" v-for="field in availableFields" :key="field">

                            <b-form-checkbox v-model=" filteredFields " :value=" field ">{{ field }}</b-form-checkbox>
                        </div>
                    </div>
               </b-row>
            </b-container>
            <div slot="modal-footer">

               <b-btn variant="default" @click=" columnsModal = false ">Close</b-btn>
            </div>
        </b-modal>

        <!-- Details modal -->
        <business-shift-details-modal :shift="selectedItem" v-model="detailsModal" :role=" role "/>
    </div>
</template>

<script>

    import FormatsNumbers from "../mixins/FormatsNumbers";
    import FormatsDates from "../mixins/FormatsDates";
    import BusinessSettings from "../mixins/BusinessSettings";
    import ShiftMap from "./ShiftMap";
    import PaginatedTable from '../mixins/PaginatedTable';
    import FilterPreserve from '../mixins/FilterPreserve';
    import UsesRole from '../mixins/UsesRole';
    import DisplaysTime from '../mixins/DisplaysTime';
    import ScopesToUser from '../mixins/ScopesToUser';

    export default {
        components : { ShiftMap },
        mixins     : [ FormatsDates, FormatsNumbers, BusinessSettings, PaginatedTable, FilterPreserve, UsesRole, ScopesToUser, DisplaysTime ],
        props: {
          manual: {
            type: Boolean,
            default: true,
          },
        },
        data() {

            return {

                total_count : 0,
                perPage     : 50,
                items       : {
                    shifts: [],
                    clientCharges: [],
                    caregiverPayments: [],
                },

                start_date      : moment().startOf('isoweek').format('MM/DD/YYYY'),
                end_date        : moment().startOf('isoweek').add(6, 'days').format('MM/DD/YYYY'),
                flag_filter     : '',
                verified_filter : '',
                payment_method  : '',
                carrier         : '',
                parent_carrier  : '',

                sortBy          : 'Visit Status',
                sortDesc        : true,

                showSummary     : false,
                dataAggregate   : {},
                totalHours      : 0,
                totalCost       : 0,
                totalFlags      : 0,

                detailsModal    : false,
                selectedItem    : {
                    client: {}
                },

                availableFields : [
                    'Day',
                    'Time',
                    'Hours',
                    'Claimant',
                    'Provider',
                    'Agency Name',
                    'EVV',
                    'EVV Message',
                    'Total Hourly',
                    'Visit Total',
                    'Disputed',
                    'Block',
                    'Visit Status'
                ],
            }
        },

        computed: {
            tz() {
              if (this.isHighLevel) {
                return 'America/Chicago';
              }
              return Intl.DateTimeFormat().resolvedOptions().timeZone;
            },
            baseUrl(){
              return `/${this.controller}/reports/data/shifts`;
            },
            appliedFilters() {
              return `?start_date=${this.start_date}&end_date=${this.end_date}&caregiver_id=${this.caregiver_id}`
              +`&client_id=${this.client_id}&flag_filter=${this.flag_filter}&verified_filter=${this.verified_filter}`
              + `&carrier=${this.carrier}&parent_carrier_id=${this.parent_carrier}&timezone=${this.tz}`;
            },

            shiftHistoryItems() {
                let items = this.items.shifts;
                console.debug("Shifts", items);
                items = items.map((item) => {
                  let format = 'h:mm A MM/DD/YYYY zz';
                  let time = '';

                  if (item.checked_in_time && item.checked_in_time !== '') {
                    let start = '';

                    if (item.shift_timezone && item.shift_timezone !== '') {
                      start = moment.utc(item.checked_in_time).tz(item.shift_timezone).format(format);
                    } else {
                      start = this.displayAndFormatTime(item.checked_in_time, '', format, this.isHighLevelOrManager);
                    }

                    let end = '';

                    if (item.checked_out_time) {
                      if (item.shift_timezone && item.shift_timezone !== '') {
                        end = moment.utc(item.checked_out_time).tz(item.shift_timezone).format(format);
                      } else {
                        end = this.displayAndFormatTime(item.checked_out_time, '', format, this.isHighLevelOrManager);
                      }
                    }

                    time = start + ' - ' + end;
                }

                    let evvMessage = '';

                    if (item.checked_in_agent) {
                        if (item.checked_in_agent.includes("DataDyne")) {
                            evvMessage += `checked_in_agent: Mobile\n`;
                        } else if (!item.checked_in_agent.includes("Twilio") && !item.checked_in_agent.includes("DataDyne")) {
                            evvMessage += `checked_in_agent: Web\n`;
                        }
                    }

                    if (item.checked_out_agent) {
                        if (item.checked_out_agent.includes("DataDyne")) {
                            evvMessage += `checked_out_agent: Mobile\n`;
                        } else if (!item.checked_out_agent.includes("Twilio") && !item.checked_out_agent.includes("DataDyne")) {
                            evvMessage += `checked_out_agent: Web\n`;
                        }
                    }

                    return {
                        'id'             : item.id,
                        'og_shift_id'    : item.og_shift_id,
                        'client_id'      : item.client_id,
                        'caregiver_id'   : item.caregiver_id,
                        'shift_timezone' : item.shift_timezone,
                        'Day'            : item.checked_in_time, // filtered in template
                        'checked_in_time': item.checked_in_time, // filtered in template
                        'Time'           : time,
                        'Hours'          : this.formatHours(item.hours),
                        'Claimant'       : item.client_name,
                        'Provider'       : item.caregiver_name,
                        'EVV'            : item.evv_verified,
                        'Agency Name'    : item.agency_name,
                        'EVV Message'    : evvMessage.trim() + (item.evv_message ? " " + item.evv_message : " "),
                        'Total Hourly'   : this.moneyFormat(item.total_hourly),
                        'Mileage'        : item.mileage,
                        'Mileage Costs'  : this.moneyFormat(item.mileage_costs),
                        'Other Expenses' : this.moneyFormat(item.other_expenses),
                        'Visit Total'    : this.determineDisplayTotal(item),
                        'Disputed'       : item.flags.includes('disputed') ? 'Yes' : 'No',
                        'Block'          : item.carrier,
                        'Visit Status'   : this.determineVisitStatus(item), //item.visit_status,
                        '_rowVariant'    : (item.disputed) ? 'danger' : null,
                        'flags'          : item.flags,
                    }
                });

                /* items = items.map((item) => {
                    item.
                }); */

                return items;
            },

            clientTotals() {
                if (this.items.clientCharges.length === 0) return {};
                return this.items.clientCharges.reduce((totals, item) => {
                    return {
                        hours: (this.parseFloatFromString(totals.hours) + this.parseFloatFromString(item.hours)).toFixed(2),
                        total: (this.parseFloatFromString(totals.total) + this.parseFloatFromString(item.total)).toFixed(2),
                        caregiver_total: (this.parseFloatFromString(totals.caregiver_total) + this.parseFloatFromString(item.caregiver_total)).toFixed(2),
                        provider_total: (this.parseFloatFromString(totals.provider_total) + this.parseFloatFromString(item.provider_total)).toFixed(2),
                        ally_total: (this.parseFloatFromString(totals.ally_total) + this.parseFloatFromString(item.ally_total)).toFixed(2),
                    }
                })
            },

            caregiverTotals() {

                if (this.items.caregiverPayments.length === 0) return {};
                return this.items.caregiverPayments.reduce((totals, item) => {
                    return {
                        amount: (this.parseFloatFromString(totals.amount) + this.parseFloatFromString(item.amount)).toFixed(2),
                        hours: (this.parseFloatFromString(totals.hours) + this.parseFloatFromString(item.hours)).toFixed(2),
                    }
                })
            },

            shiftTotals() {

                if (this.items.shifts.length === 0) return {};
                return this.items.shifts.reduce((totals, item) => {
                    return {
                        hours: (this.parseFloatFromString(totals.hours) + this.parseFloatFromString(item.hours)).toFixed(2),
                        visit_total: (this.parseFloatFromString(totals.visit_total) + this.parseFloatFromString(item.visit_total)).toFixed(2),
                        mileage: (this.parseFloatFromString(totals.mileage) + this.parseFloatFromString(item.mileage)).toFixed(2),
                        mileage_costs: (this.parseFloatFromString(totals.mileage_costs) + this.parseFloatFromString(item.mileage_costs)).toFixed(2),
                        other_expenses: (this.parseFloatFromString(totals.other_expenses) + this.parseFloatFromString(item.other_expenses)).toFixed(2),
                        flag_count: totals.flag_count + item.flag_count,
                    }
                })
            },

            summaryButtonText() { return (this.showSummary) ? 'Hide Summary' : 'Show Summary'; },
        },

        methods: {

            reloadData(){

                this.setLocalStorage('sortBy', 'Day');
                this.setLocalStorage('sortDesc', 'false');
                return this.loadTable();
            },

            loadTable() {

                if( this.loading ) return;

                this.loading = true;
                let form = new Form();

                form.submit( 'get', this.baseUrl + this.appliedFilters + this.paginationControls )
                    .then( response => {

                        if( Array.isArray( response.data.shifts ) ){

                            this.totalRows    = response.data.aggregate.total_records;
                            this.totalHours   = this.formatHours( response.data.aggregate.total_hours );
                            this.totalCost    = this.moneyFormat( response.data.aggregate.total_cost );
                            this.totalFlags   = response.data.aggregate.total_flags;
                            this.items.shifts = response.data.shifts;
                        } else {

                            this.totalRows    = 0;
                            this.totalHours   = 0;
                            this.totalCost    = 0;
                            this.totalFlags   = 0;
                            this.items.shifts = [];
                        }
                    })
                    .catch(err => {
                      console.error(err);
                    })
                    .finally( () => this.loading = false );
            },

            details(item) {
                let component = this;
                axios.get( `/${this.controller}/shifts/${item.id}` )
                    .then( response => {
                        let shift = response.data;
                        this.selectedItem = shift;
                        this.detailsModal = true;
                    })
                    .catch( error => {
                        alerts.addMessage( 'error', 'Unable to load shift details, please refresh and try again' );
                    });
            },

            determineVisitStatus(item) {
                //console.debug("determineVisitStatus", item)

                if (item.shift_in_invoices > 0) {
                    return "Complete"
                }

                if (item.under_24_hours && item.has_adls) {
                    return "Complete"
                }

                if (!item.under_24_hours) {
                    return "Requires Attention"
                }

                if (!item.has_adls) {
                    return "Requires Attention"
                }

                return "Complete"
            },

            determineDisplayTotal(item) {
                //console.debug("Running Determine Display Total", item);
                let visit_total = 0.00;

                if (item.shift_in_invoices > 0) {
                    visit_total = item.visit_total;
                } else if (!item.has_adls) {
                    visit_total = 0
                } else if (!item.under_24_hours) {
                    visit_total = 0
                } else {
                    visit_total = item.visit_total
                }

                return this.moneyFormat(visit_total)
            },

            deleteShift(item) {
                let message = 'Are you sure you wish to delete the ' + item.Hours + ' hour shift for ' + item.Provider + ' on ' + this.formatDate(item.Day) + '?';
                if (confirm(message)) {
                    let form = new Form();
                    form.submit('delete', '/business/shifts/' + item.og_shift_id)
                        .then(response => {
                            this.items.shifts = this.items.shifts.filter(function(shift) {
                                return (shift.id !== item.id);
                            });
                        })
                }
            },

            confirmShift( id ){

                if( ( this.businessSettings().ask_on_confirm === undefined || this.businessSettings().ask_on_confirm == 1 ) && !confirm( 'Are you sure you wish to confirm this shift?' ) ) return;

                let form = new Form();

                form.post( '/business/shifts/' + id + '/confirm' )
                    .then(response => {
                        this.detailsModal = false;
                        this.items.shifts.map(shift => {
                            if (shift.id === id) {
                                shift.status = response.data.data.status;
                                shift.confirmed = true;
                            }
                            return shift;
                        });
                    });
            },

            unconfirmShift(id) {
                if (this.businessSettings().ask_on_confirm === undefined || this.businessSettings().ask_on_confirm == 1) {
                    if (!confirm('Are you sure you wish to un-confirm this shift?')) {
                        return;
                    }
                }

                let form = new Form();
                form.post('/business/shifts/' + id + '/unconfirm')
                    .then(response => {
                        this.detailsModal = false;
                        this.items.shifts.map(shift => {
                            if (shift.id === id) {
                                shift.status = response.data.data.status;
                                shift.confirmed = false;
                            }
                            return shift;
                        });
                    });
            },

            confirmSelected() {
                return this.confirmShift(this.selectedItem.id);
            },

            unconfirmSelected() {
                return this.unconfirmShift(this.selectedItem.id);
            },

            printTable() {

                $(".shift-table").print();
            },

            setInitialFields() {

                this.filteredFields = this.availableFields.slice();
            },

            hoursType(item) {
                switch (item.hours_type) {
                    case 'default':
                        return 'Regular';
                    case 'overtime':
                        return 'OT';
                    case 'holiday':
                        return 'HOL';
                }
            },

            showHideSummary() {
                this.showSummary = !this.showSummary;
            },

            sortTable(a, b, key) {
                if (a.Day === 'Total') return (this.sortDesc) ? -1 : 1;
                if (b.Day === 'Total') return (this.sortDesc) ? 1 : -1;
                return null;
            }
        },


        mounted() {

        },

        watch: {

        }
    }
</script>

<style scoped>
    #loader {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        align-items: center;
        align-content: center;
        display: flex;
        justify-content: center;
        z-index: 2;
        background: rgba(0, 0, 0, 0.3);
    }
    table {
        font-size: 14px;
    }
    .table-info, .table-info>td, .table-info>th {
        font-weight: bold;
        font-size: 13px;
        background-color: #ecf7f9;
    }
    .table-sm td, 
    .table-sm th {
        padding: 0.2rem 0;
    }
    .signature > svg {
        margin: -25px 0;
        width: 100%;
        height: auto;
        max-width: 400px;
    }
    .shift-map {
        width: 100%;
        height: 200px;
    }
</style>